// extracted by mini-css-extract-plugin
module.exports = {"root":"Intro-module--root--1vaa9","divider":"Intro-module--divider--1AI82","text":"Intro-module--text--1hQwf"};